import React from "react";
import { Rnd } from "react-rnd";
import FroalaEditor from "../Uitls/CommonFroalaEditor";

const getScrollbarChildOpacity = (item) => {
  if (item?.componentStyles?.hideBoolean) return 0;

  const authoredOpacity = item?.componentStyles?.compOpacity;
  const numericOpacity = Number(authoredOpacity);
  return authoredOpacity !== undefined &&
    authoredOpacity !== null &&
    authoredOpacity !== "" &&
    Number.isFinite(numericOpacity)
    ? numericOpacity / 100
    : 1;
};

const ScrollbarComponentItems = ({
  id,
  setScrollbarItems,
  setLayerCompData,
  scrollbarItems,
  playPause,
  isEditorOn,
  canvasDimension,
  updateFontOnResize,
  setFroalaIndex,
  setContainerID,
  Scrollbars,
  createFroalaInstance,
  parse,
  playPauseRef,
  isAspectRatioLocked,
  handleComponentsDrag,
  handleComponentsDragStop,
  callOnResizeStop,
  setCurrentIdZindex,
  sendSelectedComponent,
  selectedComponent,
  handleTextChangeInLayerComp,
  handleCtrlClick,
  scrollBarExpand,
  setDisplayColorPicker,
  setVisibility,
  scrollbarContainerHeight,
  scrollbarContainerWidth,
  setSelectedComponent,
  setMultiSelectedComps,
  setIsEditorOn,
  editComponent,
}) => {
  const isScrollbarEditing = id === editComponent;

  const selectNestedItem = (e, nestedItem, index) => {
    // Nested items are only selectable while the parent scrollbar is in edit mode.
    if (!isScrollbarEditing) {
      return;
    }

    e.stopPropagation();
    if (e.nativeEvent?.stopImmediatePropagation) {
      e.nativeEvent.stopImmediatePropagation();
    }

    setFroalaIndex(index);
    setContainerID(nestedItem.id);
    if (e.currentTarget?.id) {
      setCurrentIdZindex(e.currentTarget.id);
    }
    setMultiSelectedComps?.([nestedItem]);
    setSelectedComponent(nestedItem);
    if (isEditorOn !== "true") {
      setIsEditorOn("notClickedYet");
    }
  };

  const handleDeleteKey = (scrollCompId) => {
    setLayerCompData((prevData) => {
      return prevData.map((comp) => {
        if (comp.componentType === "Scrollbar" && comp.id === id) {
          const updatedScrollbarComponents = comp.scrollbarComponents.filter(
            (item) => item.id !== scrollCompId,
          );
          setScrollbarItems(updatedScrollbarComponents);
          return {
            ...comp,
            scrollbarComponents: updatedScrollbarComponents,
          };
        }

        return comp;
      });
    });
  };

  
  return (
    <div>
      {scrollbarItems &&
        scrollbarItems.map((items, index) => (
          <div>
            {items?.componentType === "Text" && (
              <Rnd
                //ref={buttonRNDref}
                // bounds="parent"
                resizeHandleClasses={{
                  topRight: "topAnchorRight",
                  topLeft: "topAnchorLeft",
                  bottomLeft: "bottomAnchorLeft",
                  bottomRight: "bottomAnchorRight",
                  top: "horizontalAnchorCenter",
                  bottom: "horizontalAnchorCenter",
                  left: "verticallAnchorCenter",
                  right: "verticallAnchorCenter",
                }}
                disableDragging={(() => {
                  return (
                    items?.componentStyles?.hideBoolean ||
                    items?.componentStyles?.lockBoolean ||
                    !playPauseRef.current.animationCompleted ||
                    isEditorOn === "true" ||
                    (isEditorOn === "dragged" && editComponent !== id)
                  );
                })()}
                enableResizing={
                  !items?.componentStyles?.hideBoolean &&
                  !items?.componentStyles?.lockBoolean &&
                  playPauseRef.current.animationCompleted &&
                  isEditorOn !== "true" &&
                  isEditorOn !== "dragged"
                }
                size={{
                  width: items.componentStyles.width,
                  height: items.componentStyles.height,
                }}
                scale={canvasDimension.scale}
                // dragHandleClassName="moveIcon"
                enableUserSelectHack={false}
                position={{
                  x:
                    parseInt(items.componentStyles.left) +
                    (parseInt(items.componentStyles.translateX) || 0),
                  y:
                    parseInt(items.componentStyles.top) +
                    (parseInt(items.componentStyles.translateY) || 0),
                }}
                lockAspectRatio={isAspectRatioLocked}
                onDrag={(e, d) => {
                  handleComponentsDrag(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onDragStop={(e, d) => {
                  handleComponentsDragStop(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResize={(e, direction, ref, delta, position) => {
                  updateFontOnResize(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  callOnResizeStop(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onKeyDown={(e) => {
                  if (e.key === "Delete") {
                    handleDeleteKey();
                  }
                }}
                id={items.id}
                key={index}
                onDoubleClick={(e) => {
                  if (!isScrollbarEditing) return;
                  e.stopPropagation();
                  setIsEditorOn("true");
                }}
                onClick={(e) => {
                  if (e.detail === 3) return;
                  selectNestedItem(e, items, index);
                }}
                className={`${
                  // multiSelectedComps.length < 2 &&
                  selectedComponent.id === items.id
                    ? "selectedComp div-dragresize-parent cs-container textCompNew scrollbar-nested-item"
                    : "div-dragresize-parent cs-container textCompNew scrollbar-nested-item"
                } ${
                  items?.textComponentType?.addContent === "AddHeading"
                    ? "headingTextComponent"
                    : ""
                }`}
                style={{
                  pointerEvents:
                    (!playPause.animationCompleted ||
                      items.componentStyles.hideBoolean) &&
                    "none",
                  fontFamily: items.componentStyles.fontFamily,
                  //datafontSize:
                  //  items.componentStyles.datafontSize + "px",
                  fontSize: items.componentStyles.fontSize + "px",

                  fontWeight: items.componentStyles.boldClick
                    ? items.componentStyles?.fontWeightBold
                    : items.componentStyles?.fontWeight,

                  textAlign: items.componentStyles.textAlign,
                  color: items.componentStyles.color,
                  zIndex: items.componentStyles.zIndex,
                  //listStyleType:
                  // items.componentStyles.listStyletype,
                  letterSpacing: items.componentStyles.letterSpacing,
                  lineHeight: items.componentStyles.lineHeight,
                  transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                  ease: items.componentStyles.ease,
                  // transform: items.componentStyles.scale,
                  aspectLock: isAspectRatioLocked,
                  // opacity: items.componentStyles.opacity,
                  toggleScroll: items.componentStyles.toggleScroll,
                  backgroundColor: items.componentStyles.textBgColor,
                  opacity: getScrollbarChildOpacity(items),
                  fontStyle: items.componentStyles.fontStyle,

                  textTransform: items.componentStyles?.textTransform,
                  //  transformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  //marginBottom: "8px",
                  transformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  //   webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  textDecoration: items.componentStyles?.underlineClick
                    ? items.componentStyles?.strikeThroughClicked
                      ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration} `
                      : items.componentStyles?.textDecUnderline
                    : items.componentStyles?.textDecoration,
                }}
              >
                {" "}
                {items?.componentStyles.expandAndClose === true ? (
                  <div
                    id={"expandClose" + items.id}
                    ref={(e) => (scrollBarExpand.current[index] = e)}
                    style={{
                      fontFamily: items.componentStyles?.expandClose.fontFamily,
                      fontSize: items.componentStyles?.expandClose.fontSize,
                      fontWeight: items.componentStyles.expandClose.boldClick
                        ? items.componentStyles?.expandClose.fontWeightBold
                        : items.componentStyles?.expandClose.fontWeight,
                      textAlign: "right",
                      color: items.componentStyles?.expandClose?.fontColorISI,
                      backgroundColor:
                        items.componentStyles?.expandClose.textBgColorISI,
                      letterSpacing:
                        items.componentStyles?.expandClose.letterSpacing,
                      lineHeight: items.componentStyles?.expandClose.lineHeight,
                      fontStyle: items.componentStyles?.expandClose.fontStyle,
                      textTransform:
                        items.componentStyles?.expandClose.textTransform,
                      //marginBottom: "8px",
                      textDecoration: items.componentStyles?.expandClose
                        .underlineClick
                        ? items.componentStyles?.expandClose
                            .strikeThroughClicked
                          ? `${items.componentStyles?.expandClose.textDecUnderline} ${items.componentStyles?.expandClose?.textDecoration} `
                          : items.componentStyles?.expandClose?.textDecUnderline
                        : items.componentStyles?.expandClose?.textDecoration,
                      overflow: "hidden",
                    }}
                  >
                    + {items?.componentStyles.expandText}
                  </div>
                ) : (
                  ""
                )}
                {items?.componentStyles.toggleScroll === true ? (
                  <>
                    <div
                      id="upArrowButtons"
                      style={{
                        width: items.componentStyles.arrowWidth,
                        height: items.componentStyles.arrowHeight,
                        backgroundImage: `url("${items.componentStyles.scrollUpArrowbg}")`,
                        backgroundSize: items.componentStyles.backgroundSize,
                        backgroundPosition: `50% 50%`,
                        left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
                      }}
                    ></div>

                    <Scrollbars
                      style={{
                        width: "100%",
                        height: `calc(${
                          items.componentStyles.height -
                          items.componentStyles.expandClose?.expandHeight
                        }px)`,
                        top: `-${items.componentStyles.arrowHeight}px`,
                        overflow: "hidden",
                      }}
                      universal={true}
                      className="scrollBarText"
                      renderTrackVertical={({ style, ...props }) => (
                        <div
                          {...props}
                          className={"rc-scrollbars-track-v"}
                          style={{
                            ...style,
                            backgroundColor:
                              items.componentStyles.thumbColor || "transparent",
                            bottom: "2px",
                            top: `${items.componentStyles.arrowHeight + 2}px`,
                            borderRadius: "3px",
                            height: `calc( ${
                              items.componentStyles.height -
                              items.componentStyles.expandClose?.expandHeight -
                              items.componentStyles.arrowHeight * 2 -
                              4
                            }px)`,
                          }}
                        />
                      )}
                      disableDefaultStyles={true}
                      thumbSize={items.componentStyles.thumbHeight}
                      thumbMinSize={30}
                    >
                      {items.componentStyles.lockBoolean !== true &&
                      id === editComponent ? (
                        <FroalaEditor
                          forwardedRef={(e) =>
                            (createFroalaInstance.current[index] = e)
                          }
                          handleModelChange={(e) => {
                            handleTextChangeInLayerComp(
                              e,
                              index,
                              id,
                              scrollbarItems,
                            );
                          }}
                          className=""
                          defaultText={items.froalaText}
                          tag="textarea"
                          showToolBar={false}
                          scrollBarStyleWidth={
                            items.componentStyles.thumbRight * 2 +
                            items.componentStyles.trackWidth +
                            2
                          }
                        ></FroalaEditor>
                      ) : (
                        <div
                          className="fr-view"
                          style={{
                            paddingRight:
                              items.componentStyles.thumbRight * 2 +
                              items.componentStyles.trackWidth +
                              2,
                          }}
                        >
                          {parse(items.froalaText || "")}
                        </div>
                      )}
                    </Scrollbars>

                    <div
                      id="DownArrowButtons"
                      style={{
                        width: items.componentStyles.arrowWidth,
                        height: items.componentStyles.arrowHeight,
                        backgroundImage: `url("${items.componentStyles.scrollDownArrowbg}")`,
                        backgroundSize: items.componentStyles.backgroundSize,
                        backgroundPosition: `50% 50%`,
                        left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
                      }}
                    ></div>
                  </>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {items.componentStyles.lockBoolean !== true &&
                    id === editComponent ? (
                      <FroalaEditor
                        forwardedRef={(e) =>
                          (createFroalaInstance.current[index] = e)
                        }
                        handleModelChange={(e) => {
                          handleTextChangeInLayerComp(
                            e,
                            index,
                            id,
                            scrollbarItems,
                          );
                        }}
                        className=""
                        defaultText={items.froalaText}
                        tag="textarea"
                        showToolBar={false}
                      ></FroalaEditor>
                    ) : (
                      <div className="fr-view">
                        {parse(items.froalaText || "")}
                      </div>
                    )}
                  </div>
                )}
              </Rnd>
            )}
            {items?.componentType === "Reference" && (
              <Rnd
                resizeHandleClasses={{
                  topRight: "topAnchorRight",
                  topLeft: "topAnchorLeft",
                  bottomLeft: "bottomAnchorLeft",
                  bottomRight: "bottomAnchorRight",
                  top: "horizontalAnchorCenter",
                  bottom: "horizontalAnchorCenter",
                  left: "verticallAnchorCenter",
                  right: "verticallAnchorCenter",
                }}
                disableDragging={(() => {
                  return (
                    items?.componentStyles?.hideBoolean ||
                    items?.componentStyles?.lockBoolean ||
                    !playPauseRef.current.animationCompleted ||
                    isEditorOn === "true" ||
                    (isEditorOn === "dragged" && editComponent !== id)
                  );
                })()}
                enableResizing={
                  !items?.componentStyles?.hideBoolean &&
                  !items?.componentStyles?.lockBoolean &&
                  playPauseRef.current.animationCompleted &&
                  isEditorOn !== "true" &&
                  isEditorOn !== "dragged"
                }
                size={{
                  width: items.componentStyles.width,
                  height: items.componentStyles.height,
                }}
                scale={canvasDimension.scale}
                // dragHandleClassName="moveIcon"
                enableUserSelectHack={false}
                position={{
                  x:
                    parseInt(items.componentStyles.left) +
                    (parseInt(items.componentStyles.translateX) || 0),
                  y:
                    parseInt(items.componentStyles.top) +
                    (parseInt(items.componentStyles.translateY) || 0),
                }}
                lockAspectRatio={isAspectRatioLocked}
                onDrag={(e, d) => {
                  handleComponentsDrag(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onDragStop={(e, d) => {
                  handleComponentsDragStop(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResize={(e, direction, ref, delta, position) => {
                  updateFontOnResize(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  callOnResizeStop(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onKeyDown={(e) => {
                  if (e.key === "Delete") {
                    handleDeleteKey();
                  }
                }}
                id={items.id}
                key={index}
                onDoubleClick={(e) => {
                  if (!isScrollbarEditing) return;
                  e.stopPropagation();
                  setIsEditorOn("true");
                }}
                onClick={(e) => {
                  if (e.detail === 3) return;
                  selectNestedItem(e, items, index);
                }}
                className={`${
                  // multiSelectedComps.length < 2 &&
                  selectedComponent.id === items.id
                    ? "selectedComp div-dragresize-parent cs-container textCompNew scrollbar-nested-item"
                    : "div-dragresize-parent cs-container textCompNew scrollbar-nested-item"
                } ${
                  items?.textComponentType?.addContent === "AddHeading"
                    ? "headingTextComponent"
                    : ""
                }`}
                style={{
                  pointerEvents:
                    (!playPause.animationCompleted ||
                      items.componentStyles.hideBoolean) &&
                    "none",
                  fontFamily: items.componentStyles.fontFamily,
                  //datafontSize:
                  //  items.componentStyles.datafontSize + "px",
                  fontSize: items.componentStyles.fontSize + "px",

                  fontWeight: items.componentStyles.boldClick
                    ? items.componentStyles?.fontWeightBold
                    : items.componentStyles?.fontWeight,

                  textAlign: items.componentStyles.textAlign,
                  color: items.componentStyles.color,
                  zIndex: items.componentStyles.zIndex,
                  //listStyleType:
                  // items.componentStyles.listStyletype,
                  letterSpacing: items.componentStyles.letterSpacing,
                  lineHeight: items.componentStyles.lineHeight,
                  transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                  ease: items.componentStyles.ease,
                  // transform: items.componentStyles.scale,
                  aspectLock: isAspectRatioLocked,
                  // opacity: items.componentStyles.opacity,
                  toggleScroll: items.componentStyles.toggleScroll,
                  backgroundColor: items.componentStyles.textBgColor,
                  opacity: getScrollbarChildOpacity(items),
                  fontStyle: items.componentStyles.fontStyle,

                  textTransform: items.componentStyles?.textTransform,
                  //  transformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  //marginBottom: "8px",
                  transformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  //   webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  textDecoration: items.componentStyles?.underlineClick
                    ? items.componentStyles?.strikeThroughClicked
                      ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration} `
                      : items.componentStyles?.textDecUnderline
                    : items.componentStyles?.textDecoration,
                }}
              >
                {" "}
                {items?.componentStyles.expandAndClose === true ? (
                  <div
                    id={"expandClose" + items.id}
                    ref={(e) => (scrollBarExpand.current[index] = e)}
                    style={{
                      fontFamily: items.componentStyles?.expandClose.fontFamily,
                      fontSize: items.componentStyles?.expandClose.fontSize,
                      fontWeight: items.componentStyles.expandClose.boldClick
                        ? items.componentStyles?.expandClose.fontWeightBold
                        : items.componentStyles?.expandClose.fontWeight,
                      textAlign: "right",
                      color: items.componentStyles?.expandClose?.fontColorISI,
                      backgroundColor:
                        items.componentStyles?.expandClose.textBgColorISI,
                      letterSpacing:
                        items.componentStyles?.expandClose.letterSpacing,
                      lineHeight: items.componentStyles?.expandClose.lineHeight,
                      fontStyle: items.componentStyles?.expandClose.fontStyle,
                      textTransform:
                        items.componentStyles?.expandClose.textTransform,
                      //marginBottom: "8px",
                      textDecoration: items.componentStyles?.expandClose
                        .underlineClick
                        ? items.componentStyles?.expandClose
                            .strikeThroughClicked
                          ? `${items.componentStyles?.expandClose.textDecUnderline} ${items.componentStyles?.expandClose?.textDecoration} `
                          : items.componentStyles?.expandClose?.textDecUnderline
                        : items.componentStyles?.expandClose?.textDecoration,
                      overflow: "hidden",
                    }}
                  >
                    + {items?.componentStyles.expandText}
                  </div>
                ) : (
                  ""
                )}
                {items?.componentStyles.toggleScroll === true ? (
                  <>
                    <div
                      id="upArrowButtons"
                      style={{
                        width: items.componentStyles.arrowWidth,
                        height: items.componentStyles.arrowHeight,
                        backgroundImage: `url("${items.componentStyles.scrollUpArrowbg}")`,
                        backgroundSize: items.componentStyles.backgroundSize,
                        backgroundPosition: `50% 50%`,
                        left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
                      }}
                    ></div>

                    <Scrollbars
                      style={{
                        width: "100%",
                        height: `calc(${
                          items.componentStyles.height -
                          items.componentStyles.expandClose?.expandHeight
                        }px)`,
                        top: `-${items.componentStyles.arrowHeight}px`,
                        overflow: "hidden",
                      }}
                      universal={true}
                      className="scrollBarText"
                      renderTrackVertical={({ style, ...props }) => (
                        <div
                          {...props}
                          className={"rc-scrollbars-track-v"}
                          style={{
                            ...style,
                            backgroundColor:
                              items.componentStyles.thumbColor || "transparent",
                            bottom: "2px",
                            top: `${items.componentStyles.arrowHeight + 2}px`,
                            borderRadius: "3px",
                            height: `calc( ${
                              items.componentStyles.height -
                              items.componentStyles.expandClose?.expandHeight -
                              items.componentStyles.arrowHeight * 2 -
                              4
                            }px)`,
                          }}
                        />
                      )}
                      disableDefaultStyles={true}
                      thumbSize={items.componentStyles.thumbHeight}
                      thumbMinSize={30}
                    >
                      {items.componentStyles.lockBoolean !== true &&
                      id === editComponent ? (
                        <FroalaEditor
                          forwardedRef={(e) =>
                            (createFroalaInstance.current[index] = e)
                          }
                          handleModelChange={(e) => {
                            handleTextChangeInLayerComp(
                              e,
                              index,
                              id,
                              scrollbarItems,
                            );
                          }}
                          className=""
                          defaultText={items.froalaText}
                          tag="textarea"
                          showToolBar={false}
                          scrollBarStyleWidth={
                            items.componentStyles.thumbRight * 2 +
                            items.componentStyles.trackWidth +
                            2
                          }
                        ></FroalaEditor>
                      ) : (
                        <div
                          className="fr-view"
                          style={{
                            paddingRight:
                              items.componentStyles.thumbRight * 2 +
                              items.componentStyles.trackWidth +
                              2,
                          }}
                        >
                          {parse(items.froalaText || "")}
                        </div>
                      )}
                    </Scrollbars>

                    <div
                      id="DownArrowButtons"
                      style={{
                        width: items.componentStyles.arrowWidth,
                        height: items.componentStyles.arrowHeight,
                        backgroundImage: `url("${items.componentStyles.scrollDownArrowbg}")`,
                        backgroundSize: items.componentStyles.backgroundSize,
                        backgroundPosition: `50% 50%`,
                        left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
                      }}
                    ></div>
                  </>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {items.componentStyles.lockBoolean !== true &&
                    id === editComponent  ? (
                      <FroalaEditor
                        forwardedRef={(e) =>
                          (createFroalaInstance.current[index] = e)
                        }
                        handleModelChange={(e) => {
                          handleTextChangeInLayerComp(
                            e,
                            index,
                            id,
                            scrollbarItems,
                          );
                        }}
                        className=""
                        defaultText={items.froalaText}
                        tag="textarea"
                        showToolBar={false}
                      ></FroalaEditor>
                    ) : (
                      <div className="fr-view">
                        {parse(items.froalaText || "")}
                      </div>
                    )}
                  </div>
                )}
              </Rnd>
            )}
            {items?.componentType === "Footnotes" && (
              <Rnd
                resizeHandleClasses={{
                  topRight: "topAnchorRight",
                  topLeft: "topAnchorLeft",
                  bottomLeft: "bottomAnchorLeft",
                  bottomRight: "bottomAnchorRight",
                  top: "horizontalAnchorCenter",
                  bottom: "horizontalAnchorCenter",
                  left: "verticallAnchorCenter",
                  right: "verticallAnchorCenter",
                }}
                disableDragging={(() => {
                  return (
                    items?.componentStyles?.hideBoolean ||
                    items?.componentStyles?.lockBoolean ||
                    !playPauseRef.current.animationCompleted ||
                    isEditorOn === "true" ||
                    (isEditorOn === "dragged" && editComponent !== id)
                  );
                })()}
                enableResizing={
                  !items?.componentStyles?.hideBoolean &&
                  !items?.componentStyles?.lockBoolean &&
                  playPauseRef.current.animationCompleted &&
                  isEditorOn !== "true" &&
                  isEditorOn !== "dragged"
                }
                size={{
                  width: items.componentStyles.width,
                  height: items.componentStyles.height,
                }}
                scale={canvasDimension.scale}
                // dragHandleClassName="moveIcon"
                enableUserSelectHack={false}
                position={{
                  x:
                    parseInt(items.componentStyles.left) +
                    (parseInt(items.componentStyles.translateX) || 0),
                  y:
                    parseInt(items.componentStyles.top) +
                    (parseInt(items.componentStyles.translateY) || 0),
                }}
                lockAspectRatio={isAspectRatioLocked}
                onDrag={(e, d) => {
                  handleComponentsDrag(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onDragStop={(e, d) => {
                  handleComponentsDragStop(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResize={(e, direction, ref, delta, position) => {
                  updateFontOnResize(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  callOnResizeStop(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onKeyDown={(e) => {
                  if (e.key === "Delete") {
                    handleDeleteKey();
                  }
                }}
                id={items.id}
                key={index}
                onDoubleClick={(e) => {
                  if (!isScrollbarEditing) return;
                  e.stopPropagation();
                  setIsEditorOn("true");
                }}
                onClick={(e) => {
                  if (e.detail === 3) return;
                  selectNestedItem(e, items, index);
                }}
                className={`${
                  // multiSelectedComps.length < 2 &&
                  selectedComponent.id === items.id
                    ? "selectedComp div-dragresize-parent cs-container textCompNew scrollbar-nested-item"
                    : "div-dragresize-parent cs-container textCompNew scrollbar-nested-item"
                } ${
                  items?.textComponentType?.addContent === "AddHeading"
                    ? "headingTextComponent"
                    : ""
                }`}
                style={{
                  pointerEvents:
                    (!playPause.animationCompleted ||
                      items.componentStyles.hideBoolean) &&
                    "none",
                  fontFamily: items.componentStyles.fontFamily,
                  //datafontSize:
                  //  items.componentStyles.datafontSize + "px",
                  fontSize: items.componentStyles.fontSize + "px",

                  fontWeight: items.componentStyles.boldClick
                    ? items.componentStyles?.fontWeightBold
                    : items.componentStyles?.fontWeight,

                  textAlign: items.componentStyles.textAlign,
                  color: items.componentStyles.color,
                  zIndex: items.componentStyles.zIndex,
                  //listStyleType:
                  // items.componentStyles.listStyletype,
                  letterSpacing: items.componentStyles.letterSpacing,
                  lineHeight: items.componentStyles.lineHeight,
                  transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                  ease: items.componentStyles.ease,
                  // transform: items.componentStyles.scale,
                  aspectLock: isAspectRatioLocked,
                  // opacity: items.componentStyles.opacity,
                  toggleScroll: items.componentStyles.toggleScroll,
                  backgroundColor: items.componentStyles.textBgColor,
                  opacity: getScrollbarChildOpacity(items),
                  fontStyle: items.componentStyles.fontStyle,

                  textTransform: items.componentStyles?.textTransform,
                  //  transformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  //marginBottom: "8px",
                  transformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  //   webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  textDecoration: items.componentStyles?.underlineClick
                    ? items.componentStyles?.strikeThroughClicked
                      ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration} `
                      : items.componentStyles?.textDecUnderline
                    : items.componentStyles?.textDecoration,
                }}
              >
                {" "}
                {items?.componentStyles.expandAndClose === true ? (
                  <div
                    id={"expandClose" + items.id}
                    ref={(e) => (scrollBarExpand.current[index] = e)}
                    style={{
                      fontFamily: items.componentStyles?.expandClose.fontFamily,
                      fontSize: items.componentStyles?.expandClose.fontSize,
                      fontWeight: items.componentStyles.expandClose.boldClick
                        ? items.componentStyles?.expandClose.fontWeightBold
                        : items.componentStyles?.expandClose.fontWeight,
                      textAlign: "right",
                      color: items.componentStyles?.expandClose?.fontColorISI,
                      backgroundColor:
                        items.componentStyles?.expandClose.textBgColorISI,
                      letterSpacing:
                        items.componentStyles?.expandClose.letterSpacing,
                      lineHeight: items.componentStyles?.expandClose.lineHeight,
                      fontStyle: items.componentStyles?.expandClose.fontStyle,
                      textTransform:
                        items.componentStyles?.expandClose.textTransform,
                      //marginBottom: "8px",
                      textDecoration: items.componentStyles?.expandClose
                        .underlineClick
                        ? items.componentStyles?.expandClose
                            .strikeThroughClicked
                          ? `${items.componentStyles?.expandClose.textDecUnderline} ${items.componentStyles?.expandClose?.textDecoration} `
                          : items.componentStyles?.expandClose?.textDecUnderline
                        : items.componentStyles?.expandClose?.textDecoration,
                      overflow: "hidden",
                    }}
                  >
                    + {items?.componentStyles.expandText}
                  </div>
                ) : (
                  ""
                )}
                {items?.componentStyles.toggleScroll === true ? (
                  <>
                    <div
                      id="upArrowButtons"
                      style={{
                        width: items.componentStyles.arrowWidth,
                        height: items.componentStyles.arrowHeight,
                        backgroundImage: `url("${items.componentStyles.scrollUpArrowbg}")`,
                        backgroundSize: items.componentStyles.backgroundSize,
                        backgroundPosition: `50% 50%`,
                        left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
                      }}
                    ></div>

                    <Scrollbars
                      style={{
                        width: "100%",
                        height: `calc(${
                          items.componentStyles.height -
                          items.componentStyles.expandClose?.expandHeight
                        }px)`,
                        top: `-${items.componentStyles.arrowHeight}px`,
                        overflow: "hidden",
                      }}
                      universal={true}
                      className="scrollBarText"
                      renderTrackVertical={({ style, ...props }) => (
                        <div
                          {...props}
                          className={"rc-scrollbars-track-v"}
                          style={{
                            ...style,
                            backgroundColor:
                              items.componentStyles.thumbColor || "transparent",
                            bottom: "2px",
                            top: `${items.componentStyles.arrowHeight + 2}px`,
                            borderRadius: "3px",
                            height: `calc( ${
                              items.componentStyles.height -
                              items.componentStyles.expandClose?.expandHeight -
                              items.componentStyles.arrowHeight * 2 -
                              4
                            }px)`,
                          }}
                        />
                      )}
                      disableDefaultStyles={true}
                      thumbSize={items.componentStyles.thumbHeight}
                      thumbMinSize={30}
                    >
                      {items.componentStyles.lockBoolean !== true &&
                      id === editComponent ? (
                        <FroalaEditor
                          forwardedRef={(e) =>
                            (createFroalaInstance.current[index] = e)
                          }
                          handleModelChange={(e) => {
                            handleTextChangeInLayerComp(
                              e,
                              index,
                              id,
                              scrollbarItems,
                            );
                          }}
                          className=""
                          defaultText={items.froalaText}
                          tag="textarea"
                          showToolBar={false}
                          scrollBarStyleWidth={
                            items.componentStyles.thumbRight * 2 +
                            items.componentStyles.trackWidth +
                            2
                          }
                        ></FroalaEditor>
                      ) : (
                        <div
                          className="fr-view"
                          style={{
                            paddingRight:
                              items.componentStyles.thumbRight * 2 +
                              items.componentStyles.trackWidth +
                              2,
                          }}
                        >
                          {parse(items.froalaText || "")}
                        </div>
                      )}
                    </Scrollbars>

                    <div
                      id="DownArrowButtons"
                      style={{
                        width: items.componentStyles.arrowWidth,
                        height: items.componentStyles.arrowHeight,
                        backgroundImage: `url("${items.componentStyles.scrollDownArrowbg}")`,
                        backgroundSize: items.componentStyles.backgroundSize,
                        backgroundPosition: `50% 50%`,
                        left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
                      }}
                    ></div>
                  </>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {items.componentStyles.lockBoolean !== true &&
                    id === editComponent  ? (
                      <FroalaEditor
                        forwardedRef={(e) =>
                          (createFroalaInstance.current[index] = e)
                        }
                        handleModelChange={(e) => {
                          handleTextChangeInLayerComp(
                            e,
                            index,
                            id,
                            scrollbarItems,
                          );
                        }}
                        className=""
                        defaultText={items.froalaText}
                        tag="textarea"
                        showToolBar={false}
                      ></FroalaEditor>
                    ) : (
                      <div className="fr-view">
                        {parse(items.froalaText || "")}
                      </div>
                    )}
                  </div>
                )}
              </Rnd>
            )}
            {items?.componentType === "Button" && (
              <Rnd
                resizeHandleClasses={{
                  topRight: "topAnchorRight",
                  topLeft: "topAnchorLeft",
                  bottomLeft: "bottomAnchorLeft",
                  bottomRight: "bottomAnchorRight",
                  top: "horizontalAnchorCenter",
                  bottom: "horizontalAnchorCenter",
                  left: "verticallAnchorCenter",
                  right: "verticallAnchorCenter",
                }}
                disableDragging={(() => {
                  return (
                    items?.componentStyles?.hideBoolean ||
                    items?.componentStyles?.lockBoolean ||
                    !playPauseRef.current.animationCompleted ||
                    isEditorOn === "true" ||
                    isEditorOn === "dragged"
                  );
                })()}
                enableResizing={
                  !items?.componentStyles?.hideBoolean &&
                  !items?.componentStyles?.lockBoolean &&
                  playPauseRef.current.animationCompleted &&
                  isEditorOn !== "true" &&
                  isEditorOn !== "dragged"
                }
                size={{
                  width: items.componentStyles.width,
                  height: items.componentStyles.height,
                }}
                scale={canvasDimension.scale}
                position={{
                  x:
                    parseInt(items.componentStyles.left) +
                    (parseInt(items.componentStyles.translateX) || 0),
                  y:
                    parseInt(items.componentStyles.top) +
                    (parseInt(items.componentStyles.translateY) || 0),
                }}
                enableUserSelectHack={false}
                lockAspectRatio={isAspectRatioLocked}
                onDrag={(e, d) => {
                  handleComponentsDrag(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onDragStop={(e, d) => {
                  handleComponentsDragStop(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  callOnResizeStop(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResize={(e, direction, ref, delta, position) => {
                  updateFontOnResize(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                key={index}
                id={items.id}
                className={`${
                  selectedComponent.id === items.id
                    ? "selectedComp div-dragresize-parent cs-container button-container buttonResize scrollbar-nested-item"
                    : "div-dragresize-parent cs-container buttonResize scrollbar-nested-item"
                }`}
                onClick={(e) => {
                  if (e.detail === 3) return;
                  selectNestedItem(e, items, index);
                }}
                tabIndex="0"
                onKeyDown={(e) => {
                  if (e.key === "Delete") {
                    handleDeleteKey(items.id);
                  }
                }}
                style={{
                  pointerEvents:
                    (!playPause.animationCompleted ||
                      items.componentStyles.hideBoolean) &&
                    "none",
                  fontFamily: items.componentStyles.fontFamily,
                  fontSize: items.componentStyles.fontSize + "px",
                  fontWeight: items.componentStyles.boldClick
                    ? items.componentStyles?.fontWeightBold
                    : items.componentStyles?.fontWeight,
                  textAlign: items.componentStyles.textAlign,
                  color: items.componentStyles.color,
                  zIndex: items.componentStyles.zIndex,
                  letterSpacing: items.componentStyles.letterSpacing,
                  lineHeight: items.componentStyles.lineHeight,
                  targetLink: items.componentStyles.targetLink,
                  transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                  ease: items.componentStyles.ease,
                  opacity: getScrollbarChildOpacity(items),
                  fontStyle: items.componentStyles.fontStyle,
                  textTransform: items.componentStyles?.textTransform,
                  webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  textDecoration: items.componentStyles?.underlineClick
                    ? items.componentStyles?.strikeThroughClicked
                      ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration} `
                      : items.componentStyles?.textDecUnderline
                    : items.componentStyles?.textDecoration,
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                      border: items.componentStyles.border,
                      borderTopLeftRadius:
                        items.componentStyles.borderTopLeftRadius,
                      borderTopRightRadius:
                        items.componentStyles.borderTopRightRadius,
                      borderBottomLeftRadius:
                        items.componentStyles.borderBottomLeftRadius,
                      borderBottomRightRadius:
                        items.componentStyles.borderBottomRightRadius,
                      paddingTop: items.componentStyles.paddingTop,
                      paddingRight: items.componentStyles.paddingRight,
                      paddingBottom: items.componentStyles.paddingBottom,
                      paddingLeft: items.componentStyles.paddingLeft,
                      backgroundColor: items.componentStyles.backgroundColor,
                      display: "grid",
                      justifyContent: "stretch",
                      alignItems: "center",
                      textAlign: items.componentStyles.textAlign,
                      textDecoration: items.componentStyles?.underlineClick
                        ? items.componentStyles?.strikeThroughClicked
                          ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration}`
                          : items.componentStyles?.textDecUnderline
                        : items.componentStyles?.textDecoration,
                    }}
                  >
                    {items.componentStyles.lockBoolean !== true ? (
                      <FroalaEditor
                        forwardedRef={(e) =>
                          (createFroalaInstance.current[index] = e)
                        }
                        handleModelChange={(e) => {
                          handleTextChangeInLayerComp(
                            e,
                            index,
                            id,
                            scrollbarItems,
                          );
                        }}
                        className="button-froala-editor"
                        defaultText={items.froalaText}
                        tag="textarea"
                        showToolBar={false}
                      ></FroalaEditor>
                    ) : (
                      <div className="fr-view scrollbar-button-readonly">
                        {parse(items.froalaText || "")}
                      </div>
                    )}
                  </div>
                </div>
              </Rnd>
            )}

            {items?.componentType === "Image" && (
              <Rnd
                resizeHandleClasses={{
                  topRight: "topAnchorRight",
                  topLeft: "topAnchorLeft",
                  bottomLeft: "bottomAnchorLeft",
                  bottomRight: "bottomAnchorRight",
                  top: "horizontalAnchorCenter",
                  bottom: "horizontalAnchorCenter",
                  left: "verticallAnchorCenter",
                  right: "verticallAnchorCenter",
                }}
                disableDragging={
                  items?.componentStyles?.hideBoolean ||
                  items?.componentStyles?.lockBoolean ||
                  !playPauseRef.current.animationCompleted ||
                  isEditorOn === "true" ||
                  isEditorOn === "dragged"
                }
                enableResizing={
                  !items?.componentStyles?.hideBoolean &&
                  !items?.componentStyles?.lockBoolean &&
                  playPauseRef.current.animationCompleted &&
                  isEditorOn !== "true" &&
                  isEditorOn !== "dragged"
                }
                size={{
                  width: items.componentStyles.width,
                  height: items.componentStyles.height,
                }}
                // scale={canvasDimension.scale}
                position={{
                  x:
                    parseInt(items.componentStyles.left) +
                    (parseInt(items.componentStyles.translateX) || 0),
                  y:
                    parseInt(items.componentStyles.top) +
                    (parseInt(items.componentStyles.translateY) || 0),
                }}
                lockAspectRatio={isAspectRatioLocked}
                onDrag={(e, d) => {
                  handleComponentsDrag(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onDragStop={(e, d) => {
                  handleComponentsDragStop(
                    d,
                    items,
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  callOnResizeStop(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                onResize={(e, direction, ref, delta, position) => {
                  updateFontOnResize(
                    {
                      id: items.id,
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      x:
                        position.x -
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        position.y -
                        (parseInt(items.componentStyles.translateY) || 0),
                    },
                    scrollbarContainerHeight,
                    scrollbarContainerWidth,
                    scrollbarItems,
                  );
                }}
                className={
                  selectedComponent.id === items.id
                    ? "selectedComp div-dragresize-parent cs-container scrollbar-nested-item"
                    : "div-dragresize-parent cs-container scrollbar-nested-item"
                }
                data-aspect={items.componentStyles.aspectRatio}
                style={{
                  pointerEvents:
                    (!playPause.animationCompleted ||
                      items.componentStyles.hideBoolean) &&
                    "none",
                  webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                  transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                  zIndex: items.componentStyles.zIndex,
                  opacity: getScrollbarChildOpacity(items),
                  backgroundSize: `${items.componentStyles.width}px ${items.componentStyles.height}px`,
                }}
                key={index}
                id={items.id}
                onClick={(e) => {
                  setDisplayColorPicker(false);
                  setVisibility(false);
                  selectNestedItem(e, items, index);
                }}
                tabIndex="0"
                onKeyDown={(e) => {
                  if (e.key === "Delete") {
                    handleDeleteKey(items.id);
                  }
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundImage: `url(${items.componentStyles.background})`,
                    backgroundRepeat: items.componentStyles.backgroundRepeat,
                    borderTopLeftRadius:
                      items.componentStyles.borderTopLeftRadius,
                    borderTopRightRadius:
                      items.componentStyles.borderTopRightRadius,
                    borderBottomLeftRadius:
                      items.componentStyles.borderBottomLeftRadius,
                    borderBottomRightRadius:
                      items.componentStyles.borderBottomRightRadius,
                    border: items.componentStyles.border,
                    backgroundSize: "inherit",
                    ease: items.componentStyles.ease,
                    display: items?.componentStyles?.hideBoolean ? "none" : "",
                  }}
                ></div>
              </Rnd>
            )}

            {items?.componentType === "Shape" && (
              <div>
                {items.textComponentType.addContent === "rectangleShape" && (
                  <Rnd
                    resizeHandleClasses={{
                      topRight: "topAnchorRight",
                      topLeft: "topAnchorLeft",
                      bottomLeft: "bottomAnchorLeft",
                      bottomRight: "bottomAnchorRight",
                      top: "horizontalAnchorCenter",
                      bottom: "horizontalAnchorCenter",
                      left: "verticallAnchorCenter",
                      right: "verticallAnchorCenter",
                    }}
                    disableDragging={
                      items?.componentStyles?.hideBoolean ||
                      items?.componentStyles?.lockBoolean ||
                      !playPauseRef.current.animationCompleted ||
                      isEditorOn === "true" ||
                      isEditorOn === "dragged"
                    }
                    enableResizing={
                      !items?.componentStyles?.hideBoolean &&
                      !items?.componentStyles?.lockBoolean &&
                      playPauseRef.current.animationCompleted &&
                      isEditorOn !== "true" &&
                      isEditorOn !== "dragged"
                    }
                    size={{
                      width: items.componentStyles.width,
                      height: items.componentStyles.height,
                    }}
                    scale={canvasDimension.scale}
                    position={{
                      x:
                        parseInt(items.componentStyles.left) +
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        parseInt(items.componentStyles.top) +
                        (parseInt(items.componentStyles.translateY) || 0),
                    }}
                    lockAspectRatio={isAspectRatioLocked}
                    onDrag={(e, d) => {
                      handleComponentsDrag(
                        d,
                        items,
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    onDragStop={(e, d) => {
                      handleComponentsDragStop(
                        d,
                        items,
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    onResizeStop={(e, direction, ref, delta, position) => {
                      callOnResizeStop(
                        {
                          id: items.id,
                          width: ref.offsetWidth,
                          height: ref.offsetHeight,
                          x:
                            position.x -
                            (parseInt(items.componentStyles.translateX) || 0),
                          y:
                            position.y -
                            (parseInt(items.componentStyles.translateY) || 0),
                        },
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    onResize={(e, direction, ref, delta, position) => {
                      updateFontOnResize(
                        {
                          id: items.id,
                          width: ref.offsetWidth,
                          height: ref.offsetHeight,
                          x:
                            position.x -
                            (parseInt(items.componentStyles.translateX) || 0),
                          y:
                            position.y -
                            (parseInt(items.componentStyles.translateY) || 0),
                        },
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    key={index}
                    id={items.id}
                    onClick={(e) => selectNestedItem(e, items, index)}
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === "Delete") {
                        handleDeleteKey(items.id);
                      }
                    }}
                    className={`${
                      selectedComponent.id === items.id
                        ? `${
                            !selectedComponent.componentStyles?.hideBoolean &&
                            "selectedComp"
                          } div-dragresize-parent cs-container scrollbar-nested-item`
                        : "div-dragresize-parent cs-container scrollbar-nested-item"
                    }`}
                    style={{
                      pointerEvents:
                        (!playPause.animationCompleted ||
                          items.componentStyles.hideBoolean) &&
                        "none",
                      zIndex: items.componentStyles.zIndex,
                      webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                      transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        opacity: getScrollbarChildOpacity(items),
                        pointerEvents: items?.componentStyles?.hideBoolean
                          ? "none"
                          : "",
                        backgroundColor: items.componentStyles.backgroundColor,
                        border: items.componentStyles.border,
                        paddingTop: items.componentStyles.paddingTop,
                        paddingRight: items.componentStyles.paddingRight,
                        paddingBottom: items.componentStyles.paddingBottom,
                        paddingLeft: items.componentStyles.paddingLeft,
                        borderTopLeftRadius:
                          items.componentStyles.borderTopLeftRadius,
                        borderTopRightRadius:
                          items.componentStyles.borderTopRightRadius,
                        borderBottomLeftRadius:
                          items.componentStyles.borderBottomLeftRadius,
                        borderBottomRightRadius:
                          items.componentStyles.borderBottomRightRadius,
                        transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                        aspectLock: isAspectRatioLocked,
                      }}
                    >
                      <div className="shapesOnCanvas"></div>
                    </div>
                  </Rnd>
                )}
                {items.textComponentType.addContent === "circleShape" && (
                  <Rnd
                    resizeHandleClasses={{
                      topRight: "topAnchorRight",
                      topLeft: "topAnchorLeft",
                      bottomLeft: "bottomAnchorLeft",
                      bottomRight: "bottomAnchorRight",
                      top: "horizontalAnchorCenter",
                      bottom: "horizontalAnchorCenter",
                      left: "verticallAnchorCenter",
                      right: "verticallAnchorCenter",
                    }}
                    disableDragging={
                      items?.componentStyles?.hideBoolean ||
                      items?.componentStyles?.lockBoolean ||
                      !playPauseRef.current.animationCompleted ||
                      isEditorOn === "true" ||
                      isEditorOn === "dragged"
                    }
                    enableResizing={
                      !items?.componentStyles?.hideBoolean &&
                      !items?.componentStyles?.lockBoolean &&
                      playPauseRef.current.animationCompleted &&
                      isEditorOn !== "true" &&
                      isEditorOn !== "dragged"
                    }
                    size={{
                      width: items.componentStyles.width,
                      height: items.componentStyles.height,
                    }}
                    scale={canvasDimension.scale}
                    position={{
                      x:
                        parseInt(items.componentStyles.left) +
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        parseInt(items.componentStyles.top) +
                        (parseInt(items.componentStyles.translateY) || 0),
                    }}
                    lockAspectRatio={isAspectRatioLocked}
                    onDrag={(e, d) => {
                      handleComponentsDrag(
                        d,
                        items,
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    onDragStop={(e, d) => {
                      handleComponentsDragStop(
                        d,
                        items,
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    onResize={(e, direction, ref, delta, position) => {
                      updateFontOnResize(
                        {
                          id: items.id,
                          width: ref.offsetWidth,
                          height: ref.offsetHeight,
                          x:
                            position.x -
                            (parseInt(items.componentStyles.translateX) || 0),
                          y:
                            position.y -
                            (parseInt(items.componentStyles.translateY) || 0),
                        },
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    key={index}
                    id={items.id}
                    className={`${
                      selectedComponent.id === items.id
                        ? "selectedComp div-dragresize-parent cs-container scrollbar-nested-item"
                        : "div-dragresize-parent cs-container scrollbar-nested-item"
                    }`}
                    onClick={(e) => {
                      setVisibility(false);
                      selectNestedItem(e, items, index);
                    }}
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === "Delete") {
                        handleDeleteKey(items.id);
                      }
                    }}
                    style={{
                      // opacity:
                      //   items.id === selectedComponent.id
                      //     ? 1
                      //     : items.componentStyles.opacity,
                      opacity: getScrollbarChildOpacity(items),
                      zIndex: items.componentStyles.zIndex,

                      // opacity: items?.componentStyles?.opacity,
                      webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                      transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: items.componentStyles.borderRadius,
                        border: items.componentStyles.border,
                        backgroundColor: items.componentStyles.backgroundColor,

                        visibility: items.componentStyles.hideBoolean
                          ? "hidden"
                          : "visible",
                        // display:
                        //   !playPause.animationCompleted ||
                        //   items.componentStyles.hideBoolean
                        //     ? "none"
                        //     : "block",

                        /*  backgroundColor:
                                        items.componentStyles.backgroundColor, */
                        paddingTop: items.componentStyles.paddingTop,
                        // zIndex: items.componentStyles.zIndex,
                        /*  borderRadius:
                                        items.componentStyles.borderRadius,
                                      border: items.componentStyles.border, */
                        transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                        ease: items.componentStyles.ease,
                        // opacity:
                        //   items.id === selectedComponent.id
                        //     ? 1
                        //     : items.componentStyles.opacity,
                        // transform: items.componentStyles.scale,
                      }}
                      // onMouseUp={(e) => {
                      //   isDragged.mouseDown = false;
                      //   sendSelectedComponent(e, index);
                      //   setFroalaIndex(index);
                      //   setContainerID(items.id);
                      //   setCurrentIdZindex(e.currentTarget.id);
                      // }}
                    >
                      <div className="shapesOnCanvas"></div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",

                        /*  backgroundColor:
                                        items.componentStyles.backgroundColor, */
                        paddingTop: items.componentStyles.paddingTop,
                        // zIndex: items.componentStyles.zIndex,
                        /*  borderRadius:
                                        items.componentStyles.borderRadius,
                                      border: items.componentStyles.border, */
                        transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                        ease: items.componentStyles.ease,
                        // transform: items.componentStyles.scale,
                        // opacity:
                        //   toggleAnimatedBanner === true ||
                        //   items?.componentStyles?.hideBoolean ===
                        //     true
                        //     ? items?.componentStyles?.opacity
                        //     : items?.componentStyles?.compOpacity /
                        //       100,
                      }}
                    ></div>
                  </Rnd>
                )}

                {(items?.textComponentType?.addContent === "polygonShape" ||
                  items?.textComponentType?.addContent === "triangleShape" ||
                  items?.textComponentType?.addContent === "hexagonShape") && (
                  <Rnd
                    resizeHandleClasses={{
                      topRight: "topAnchorRight",
                      topLeft: "topAnchorLeft",
                      bottomLeft: "bottomAnchorLeft",
                      bottomRight: "bottomAnchorRight",
                      top: "horizontalAnchorCenter",
                      bottom: "horizontalAnchorCenter",
                      left: "verticallAnchorCenter",
                      right: "verticallAnchorCenter",
                    }}
                    disableDragging={
                      items?.componentStyles?.hideBoolean ||
                      items?.componentStyles?.lockBoolean ||
                      !playPauseRef.current.animationCompleted ||
                      isEditorOn === "true" ||
                      isEditorOn === "dragged"
                    }
                    enableResizing={
                      !items?.componentStyles?.hideBoolean &&
                      !items?.componentStyles?.lockBoolean &&
                      playPauseRef.current.animationCompleted &&
                      isEditorOn !== "true" &&
                      isEditorOn !== "dragged"
                    }
                    size={{
                      width: items.componentStyles.width,
                      height: items.componentStyles.height,
                    }}
                    // scale={canvasDimension.scale}
                    position={{
                      x:
                        parseInt(items.componentStyles.left) +
                        (parseInt(items.componentStyles.translateX) || 0),
                      y:
                        parseInt(items.componentStyles.top) +
                        (parseInt(items.componentStyles.translateY) || 0),
                    }}
                    lockAspectRatio={isAspectRatioLocked}
                    onDrag={(e, d) => {
                      handleComponentsDrag(
                        d,
                        items,
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    onDragStop={(e, d) => {
                      handleComponentsDragStop(
                        d,
                        items,
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    onResize={(e, direction, ref, delta, position) => {
                      updateFontOnResize(
                        {
                          id: items.id,
                          width: ref.offsetWidth,
                          height: ref.offsetHeight,
                          x:
                            position.x -
                            (parseInt(items.componentStyles.translateX) || 0),
                          y:
                            position.y -
                            (parseInt(items.componentStyles.translateY) || 0),
                        },
                        scrollbarContainerHeight,
                        scrollbarContainerWidth,
                        scrollbarItems,
                      );
                    }}
                    key={index}
                    id={items.id}
                    // className={
                    //   `${
                    //     // multiSelectedComps.length < 2 &&
                    //     selectedComponent.id === items.id
                    //       ? "selectedComp div-dragresize-parent cs-container "
                    //       : "div-dragresize-parent cs-container"
                    //   }`
                    //   //   +
                    //   //   " " +
                    //   //   `${
                    //   //     multiSelectedComps.length > 1 &&
                    //   //     items.multiSelected === true
                    //   //       ? "multipleSelection"
                    //   //       : ""
                    //   //   }`
                    // }
                    className={
                      selectedComponent.id === items.id
                        ? "selectedComp div-dragresize-parent cs-container scrollbar-nested-item"
                        : "div-dragresize-parent cs-container scrollbar-nested-item"
                    }
                    onClick={(e) => {
                      setVisibility(false);
                      selectNestedItem(e, items, index);
                    }}
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === "Delete") {
                        handleDeleteKey(items.id);
                      }
                    }}
                    style={{
                      pointerEvents:
                        (!playPause.animationCompleted ||
                          items.componentStyles.hideBoolean) &&
                        "none",
                      zIndex: items.componentStyles.zIndex,
                      opacity:
                        items?.componentStyles?.hideBoolean === true && 0,
                      webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
                      transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
                    }}
                    // className="div-dragresize-parent cs-container"
                  >
                    <div
                      className="shapesOnCanvas"
                      style={{
                        width: "100%",
                        height: "100%",
                        // transform: `rotate(${items.componentStyles.rotation}) scale(${canvasDimension.scale})`,
                        // left: items.componentStyles.left,
                        // top: items.componentStyles.top,
                        // zIndex: items.componentStyles.zIndex,
                        ease: items.componentStyles.ease,
                        // width: items.componentStyles.width,
                        // height: items.componentStyles.height,
                        transform: items.componentStyles.scale,
                        aspectLock: isAspectRatioLocked,
                        // opacity:
                        //   toggleAnimatedBanner === true ||
                        //   items?.componentStyles?.hideBoolean ===
                        //     true
                        //     ? items?.componentStyles?.opacity
                        //     : items?.componentStyles?.compOpacity /
                        //       100,
                      }}
                      // onMouseUp={(e) => {
                      //   isDragged.mouseDown = false;
                      //   sendSelectedComponent(e, index);
                      //   setFroalaIndex(index);
                      //   setContainerID(items.id);
                      //   setCurrentIdZindex(e.currentTarget.id);
                      // }}
                    >
                      {items?.textComponentType?.addContent ===
                        "triangleShape" && (
                        <img
                          className="triangleImage"
                          src={
                            items?.textComponentType?.addContent ===
                              "triangleShape" && items.triImage
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            pointerEvents: "none",
                            opacity: getScrollbarChildOpacity(items),
                          }}
                          alt=""
                        />
                      )}
                      {items?.textComponentType?.addContent ===
                        "polygonShape" && (
                        <img
                          className="pentagonImage"
                          style={{
                            width: "100%",
                            height: "100%",
                            pointerEvents: "none",
                            opacity: getScrollbarChildOpacity(items),
                            //border: items.componentStyles.border,
                          }}
                          src={
                            items?.textComponentType?.addContent ===
                              "polygonShape" && items.pentImage
                          }
                          alt=""
                        />
                      )}
                      {items?.textComponentType?.addContent ===
                        "hexagonShape" && (
                        <img
                          className="img-fluid"
                          style={{
                            width: "100%",
                            height: "100%",
                            pointerEvents: "none",
                            opacity: getScrollbarChildOpacity(items),
                          }}
                          src={
                            items?.textComponentType?.addContent ===
                              "hexagonShape" && items.hexImage
                          }
                          alt=""
                        />
                      )}
                    </div>
                  </Rnd>
                )}
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default ScrollbarComponentItems;
